<section class="product-card-placeholder">
  <span class="mat-display-2 primary">
    <ng-content></ng-content>
  </span>
</section>